import { useDirection } from '@radix-ui/react-direction';
import * as ProgressPrimitive from '@radix-ui/react-progress';
import * as React from 'react';

import { cn } from '@heidi/utils';

import { useIsExperimentalDesignSystemForms } from '../hooks/use-is-experimental-design-system-forms';
import { progressIndicatorClassesExperimental } from './progress.experimental.styles';
import { progressIndicatorClasses, progressRootClasses } from './progress.styles';
import type { ProgressProps } from './progress.types';

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  ProgressProps
>(({ className, value, ...props }, ref) => {
  // Animate the progress bar based on the writing mode and direction
  const dir = useDirection();
  const offset = 100 - (value || 0);
  const sign = dir === 'rtl' ? 1 : -1;

  const isExperimentalForms = useIsExperimentalDesignSystemForms();

  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(progressRootClasses, className)}
      data-experimental-form={isExperimentalForms}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className={
          isExperimentalForms
            ? progressIndicatorClassesExperimental
            : progressIndicatorClasses
        }
        style={{ transform: `translateX(${sign * offset}%)` }}
      />
    </ProgressPrimitive.Root>
  );
});
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
